import { createContext, JSX, useContext, useMemo, useState } from 'react';
import {
  type AppErrorInterface,
  type AppErrorHandlerProviderContextProps,
  type AppErrorHandlerProviderProps,
  UseAppErrorHandler,
} from './types';
import { AppErrorHandler } from './app-error-handler';

export const AppErrorHandlerProviderContext =
  createContext<AppErrorHandlerProviderContextProps>({
    error: null,
    setError: () => undefined,
  });

export function AppErrorHandlerProvider({
  children,
}: AppErrorHandlerProviderProps): JSX.Element {
  const [error, setError] = useState<AppErrorInterface | null>(null);

  const value = useMemo(() => ({ error, setError }), [error, setError]);

  return (
    <AppErrorHandlerProviderContext.Provider value={value}>
      <AppErrorHandler errorUserInterfaceType={error?.userInterface}>
        {children}
      </AppErrorHandler>
    </AppErrorHandlerProviderContext.Provider>
  );
}

export const useAppErrorHandler: UseAppErrorHandler = () =>
  useContext(AppErrorHandlerProviderContext);
